/*
 * Helpers de formato de fechas/horas unificados (Punto 2).
 *
 * Toda la app muestra fechas como dd/mm/aaaa con locale es-ES y zona
 * Europe/Madrid. Solo fichajes y auditoría muestran segundos.
 *
 * Reglas:
 *   - Valor null / undefined / '' / fecha inválida → '—'.
 *   - NO usar estos helpers para generar valores ISO de <input type="date">
 *     ni para enviar al backend (eso sigue en formato YYYY-MM-DD con 'en-CA').
 */

const VACIO = '—'
const TZ = 'Europe/Madrid'
const LOCALE = 'es-ES'

// Convierte el valor de entrada en un Date válido, o null si no se puede.
// Normaliza 'YYYY-MM-DD HH:MM:SS' (formato SQLite) a ISO con 'T' porque Safari
// no parsea el separador de espacio.
function aDate(valor) {
  if (valor === null || valor === undefined || valor === '') return null
  if (valor instanceof Date) return isNaN(valor.getTime()) ? null : valor
  if (typeof valor === 'string') {
    let s = valor.trim()
    if (!s) return null
    const m = s.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2})?)/)
    if (m) s = `${m[1]}T${m[2]}`
    const d = new Date(s)
    return isNaN(d.getTime()) ? null : d
  }
  const d = new Date(valor)
  return isNaN(d.getTime()) ? null : d
}

// 'HH:mm' o 'HH:mm:ss' de un Date, en zona Madrid.
function horaDe(d, conSegundos) {
  return d.toLocaleTimeString(LOCALE, {
    timeZone: TZ,
    hour: '2-digit',
    minute: '2-digit',
    ...(conSegundos ? { second: '2-digit' } : {}),
    hour12: false
  })
}

// dd/mm/aaaa
export function formatearFecha(valor) {
  const d = aDate(valor)
  if (!d) return VACIO
  return d.toLocaleDateString(LOCALE, { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric' })
}

// dd/mm/aaaa HH:mm
export function formatearFechaHora(valor) {
  const d = aDate(valor)
  if (!d) return VACIO
  return `${formatearFecha(d)} ${horaDe(d, false)}`
}

// dd/mm/aaaa HH:mm:ss (solo fichajes y auditoría)
export function formatearFechaHoraSeg(valor) {
  const d = aDate(valor)
  if (!d) return VACIO
  return `${formatearFecha(d)} ${horaDe(d, true)}`
}

// HH:mm — acepta cadenas de solo hora ('HH:mm' / 'HH:mm:ss') o fechas completas.
export function formatearHora(valor) {
  if (valor === null || valor === undefined || valor === '') return VACIO
  if (typeof valor === 'string') {
    const t = valor.trim().match(/^(\d{2}):(\d{2})(?::\d{2})?$/)
    if (t) return `${t[1]}:${t[2]}`
  }
  const d = aDate(valor)
  if (!d) return VACIO
  return horaDe(d, false)
}
